import React from "react";
import { Container } from "react-bootstrap";
import { LAST_CALL, PHONES } from "../data/shop";
import { Zia } from "./Zia";
import "./LastCall.css";

const shopPhone = PHONES[0];

export const LastCall = () => (
  <section className="last-call">
    <Container>
      <div className="last-call__card frame">
        <div className="last-call__copy">
          <span className="last-call__tag">
            <Zia size={13} />
            Last Call
          </span>
          <h2 className="last-call__headline">{LAST_CALL.headline}</h2>
          <p className="last-call__body">{LAST_CALL.body}</p>
        </div>
        <div className="last-call__actions">
          <a
            className="btn-shop"
            href={LAST_CALL.bookingUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Book with {LAST_CALL.barber}
          </a>
          <a className="btn-ghost" href={shopPhone.href}>
            {LAST_CALL.cta}
          </a>
        </div>
      </div>
    </Container>
  </section>
);
